import { Middleware } from 'redux'
import { TranslationsActionTypes, TranslationsActionType } from '../store/Translations/types'
import { AuthActionType, AuthActionTypes } from '../store/Auth/types'

const localStorageEnchancer: Middleware = () =>
  (next) =>
    (action: TranslationsActionType | AuthActionType) => {
      switch (action.type) {
        case TranslationsActionTypes.SWITCH_TRANSLATION:
          window.localStorage.setItem('lang', action.language)
          break
        case AuthActionTypes.POST_LOGIN_SUCCESS:
          window.localStorage.setItem('token', action.response.accessToken)
          window.localStorage.setItem('refreshToken', action.response.refreshToken)
          break
        case AuthActionTypes.CHECK_BANK_ID_STATUS_SUCCESS:
          if (action.response.accessToken && action.response.refreshToken) {
            window.localStorage.setItem('token', action.response.accessToken)
            window.localStorage.setItem('refreshToken', action.response.refreshToken)
          }
          break
        case AuthActionTypes.LOGOUT:
          window.localStorage.removeItem('token')
          window.localStorage.removeItem('refreshToken')
          sessionStorage.removeItem('patient_filters')
          break
      }
      return next(action)
    }

export default localStorageEnchancer
